// extracted by mini-css-extract-plugin
export default {"labelFN":"fouw7HAs0Li","textareaHeightLg":"fouQZH3YWrs"};